import React from 'react';
import formatter from '@payit/payit-formatter';
import { TextArea, } from '@payit/cool-web-ui-library';
import PropTypes from 'prop-types';
import { Button, } from 'react-bootstrap';
import ObjectUtils from '../../../../modules/ObjectUtils';
import VerticalLabelList from '../../../label/VerticalLabelList';
import FieldSet from '../../../fieldset/FieldSet';
import TransactionService from '../../../../service/TransactionService';
import Numbers from '../../../../modules/Numbers';

class GenResolveView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transaction: {},
      isValid: false,
      isEmptySearch: true,
    };
    this.fetchTransactionData(props.transactionId);
  }

  fetchTransactionData(transactionId) {
    this.setState({ isValid: false, });

    const reducer = res => res.data;
    const isEmptySearch = (a1 = {}, a2 = {}) => {
      const { length, } = Object.keys(a1);
      return length === 0 && Object.keys(a2).length === 0;
    };
    const isRefunded = (paymentHistory = []) => paymentHistory.filter(item => item.action.includes('REFUND')).length > 0;
    const isChargeback = (paymentHistory = []) => paymentHistory.filter(item => item.action.includes('CHARGEBACK')).length > 0;
    const isCashTransaction = (transaction) => transaction && transaction.paymentAccountType === 'CASH';
    const returnMatch = (v2 = {}, v3 = {}) => {
      if (Object.keys(v2).length > 0) {
        const transaction = {
          ...v2,
        };
        const paymentHistory = ObjectUtils.formatStringAsJSONArray(transaction.paymentHistory);
        return {
          version: 2,
          ...transaction,
          transactionFees: Numbers.toNumber(transaction.serviceFeeAmount),
          isRefunded: isRefunded(paymentHistory),
          hasChargeback: isChargeback(paymentHistory),
        };
      }

      if (Object.keys(v3).length > 0) {
        const paymentHistory = ObjectUtils.formatStringAsJSONArray(v3.paymentHistory);
        const serviceOfferingSet = new Set();

        // Fees is a Map in Mongo so if there are multiple fees, then warehouse has it in
        // individual columns named for Fee Type i.e. fees_PAYIT_FEE
        // with column content {"value":"2.000000","currencyCode":"USD"}.
        // For single fees, the fee is in column named fees with Fee Type included in content i.e.
        // {"CREDIT_CARD":{"value":"3.580000","currencyCode":"USD"}}
        const fees = ObjectUtils.formatStringAsJSONArray('[]');
        if (v3.fees == null) {
          Object.keys(v3).filter(key => key.startsWith('fees_')).forEach(fee => (v3[fee] == null ? '' : fees.push(ObjectUtils.formatStringAsJSONObject(v3[fee]))));
        } else {
          const _fees = ObjectUtils.formatStringAsJSONObject(v3.fees);
          Object.keys(_fees).map(key => fees.push(_fees[key]));
        }
        v3.lineItems.forEach(lineItem => {
          if (lineItem.fees) {
            const _fees = ObjectUtils.formatStringAsJSONObject(lineItem.fees);
            Object.keys(_fees).map(key => fees.push(_fees[key]));
          }
          serviceOfferingSet.add(lineItem.serviceOfferingId);
        });

        return {
          version: 3,
          ...v3,
          chargedAmount: `${Numbers.addAll(
            v3.lineItems.map(item => Math.round(Numbers.toNumber(item.amount.value) * 100))
          )}`.replace(/\./g, ''),
          transactionFees: `${Numbers.addAll(
            Object.keys(fees).map(key => Math.round(Numbers.toNumber(fees[key].value) * 100))
          )}`.replace(/\./g, ''),
          isRefunded: isRefunded(paymentHistory),
          hasChargeback: isChargeback(paymentHistory),
          serviceOfferingId: [ ...serviceOfferingSet, ].join(', '),
        };
      }
      return {
        version: null,
        transaction: null,
      };
    };
    let isCash;
    let isEmpty;

    Promise.all([
      TransactionService.getTransactionDetail(transactionId).then(reducer),
      TransactionService.getV3TransactionDetail(transactionId).then(reducer),
    ])
      .then(([ v2TransactionsResponse, v3TransactionsResponse, ]) => {
        const { transaction, } = v2TransactionsResponse;
        const { v3transaction, } = v3TransactionsResponse;
        isCash = isCashTransaction(v3transaction);
        isEmpty = isEmptySearch(transaction, v3transaction);
        if (!isEmpty) {
          const value = returnMatch(transaction, v3transaction);
          this.setState({
            transaction: value,
          });
        } else {
          this.setState({
            isEmptySearch: isEmpty,
          });
        }
      })
      .finally(() => {
        this.setState({
          isValid: !isEmpty && !isCash,
          isCash,
        });
      });
  }

  formatDetails() {
    const {
      transaction, isValid, isEmptySearch, isCash,
    } = this.state;
    const data = {};

    if (isValid === false && isEmptySearch) {
      if (!isCash) {
        return <p className="small text-danger">Not Found</p>;
      }
      return <p className="small text-danger">Cannot display cash transactions.</p>;
    }

    if (!transaction && isValid === undefined) {
      return null;
    }

    data.transaction = transaction;

    data.getTransactionDetails = () => {
      const items = VerticalLabelList.toList({
        'Transaction ID': transaction.id,
        Type: transaction.transactionType,
        'Payment Account Type': transaction.paymentAccountType,
        Amount: formatter.money.printMoney(transaction.chargedAmount),
        Fees: formatter.money.printMoney(transaction.transactionFees),
        Status:
          transaction.status
          || transaction.errorMessage
          || transaction.achData_achStatus
          || ObjectUtils.formatStringAsJSONObject(transaction.ccData_processorResponse)
            .responseMessage
          || ObjectUtils.formatStringAsJSONObject(transaction.cashData).cashStatus,
        'Service Offering Id(s)': transaction.serviceOfferingId,
        'Has Refunds': transaction.isRefunded ? 'Yes' : 'No',
        'Has a chargeback': transaction.hasChargeback ? 'Yes' : 'No',
      });

      return (
        <FieldSet title="Details">
          <VerticalLabelList items={items} />
        </FieldSet>
      );
    };

    return data.getTransactionDetails();
  }

  lineItemSelect = (lineItems) => {
    if (!lineItems) {
      return null;
    }

    return (
      <div>
        LineItem(s): <br />
        {lineItems.map((li, index) => {
          return (
            <div key={`line-item-${index}`}>
              <input className='m-1' value={`lineItem${index}`} type='checkbox' />
              <span className='m-1'>{`${li.id}- SOID: ${li.serviceOfferingId} Amount: ${formatter.money.printMoney(Math.round(Numbers.toNumber(li.amount.value) * 100))}`}</span>
            </div>
          );
        })}
      </div>
    );
  };

  handleSubmit = (e) => {
    this.genResolveTransaction(e);
  };

  genResolveTransaction = () => {
    // TODO This needs to be hooked up to the completed endpoint
     
    alert('Need to hook up genresolve');
  };

  render() {
    const { transaction, isCash, } = this.state;
    const isDisabled = isCash;
    return (
      <div className="container m-1">
        {this.formatDetails()}
        <div className="row m-1" />
        <form onSubmit={this.handleSubmit}>
          {transaction.version === 3 && !isCash ? this.lineItemSelect(transaction.lineItems) : null}
          <div className="row m-1">
            Gen Resolve Reason:
            <select className='m-1' disabled={isDisabled}>
              <option>Reason 1</option>
              <option>Reason 2</option>
              <option>etc</option>
            </select>
          </div>
          <div className="row m-1">
            Root Cause:
            <TextArea disabled={isDisabled} />
          </div>
          <div className="row m-1">
            <Button className='m-1' type="submit" disabled={isDisabled}>Gen Resolve</Button>
            <Button className='m-1' onClick={() => this.props.events.emit('close')}>Cancel</Button>
          </div>
        </form>
      </div>
    );
  }
}

GenResolveView.propTypes = {
  transactionId: PropTypes.string.isRequired,
  events: PropTypes.object.isRequired,
  'events.emit': PropTypes.func.isRequired,
};

export default GenResolveView;
